module.exports = __webpack_public_path__ + "static/img/pin-multi-scheduled-mandatory-irregular.02ef28e.svg";